import styled from 'styled-components'

export const List = styled.ul`
  line-height: 1.6em;
  ${p => p.theme.styles.list};
  margin-top: 0;
  margin-bottom: 0;
`
